import React from 'react';
import { ArrowRight, Shield, Sparkles, Zap } from 'lucide-react';
interface SecurityCTAProps {
  'data-id'?: string;
}
export const SecurityCTA: React.FC<SecurityCTAProps> = ({
  'data-id': dataId
}) => {
  return <section className="w-full bg-gradient-to-b from-[#121212] via-[#0f0f0f] to-[#121212] py-24 md:py-32 px-6 md:px-8" data-id="element-1630">
      <div className="w-full max-w-[1280px] mx-auto relative" data-id="element-1631">
        {/* White glow effect - matching pricing cards exactly */}
        <div className="absolute inset-0 rounded-[32px] blur-3xl bg-white opacity-30" style={{
        transform: 'scale(0.92)'
      }} data-id="element-1632" />

        {/* Main card with enhanced gradient border effect */}
        <div className="relative bg-gradient-to-br from-[#1a1a1a] via-[#1a1a1a] to-[#1a1a1a] rounded-[32px] px-8 md:px-12 py-12 md:py-16 border border-white/10 shadow-[0_8px_24px_rgba(0,0,0,0.3)] hover:shadow-[0_12px_32px_rgba(0,0,0,0.4)] overflow-hidden transition-all duration-500" data-id="element-1633">
          {/* Subtle grid pattern overlay */}
          <div className="absolute inset-0 opacity-[0.02]" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }} data-id="element-1634" />

          {/* Accent line at top */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-1.5 bg-gradient-to-r from-transparent via-[#3ab795] to-transparent rounded-full shadow-[0_0_20px_rgba(58,183,149,0.6)]" data-id="element-1635" />

          <div className="relative flex flex-col items-center gap-8 max-w-[700px] mx-auto text-center" data-id="element-1636">
            {/* Badge pill */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm" data-id="element-1637">
              <Sparkles className="w-4 h-4 text-[#3ab795]" strokeWidth={2.5} data-id="element-1638" />
              <span className="text-sm font-medium text-[#3ab795] uppercase tracking-wide" data-id="element-1639">
                Ready to Scale?
              </span>
            </div>

            {/* Heading with animated underline */}
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight" data-id="element-1640">
              <span className="text-white" data-id="element-1641">Automate Your Deal Flow. </span>
              <span className="relative inline-block text-[#3ab795]" data-id="element-1642">
                Close More Properties.
                <span className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-[#3ab795] to-[#2d9575] rounded-full shadow-[0_0_10px_rgba(58,183,149,0.5)]" data-id="element-1643" />
              </span>
            </h2>

            {/* Subheading */}
            <div className="flex flex-col items-center gap-4" data-id="element-1644">
              <p className="text-lg md:text-xl text-[#b8bcc8] leading-relaxed max-w-[600px]" data-id="element-1645">
                Let AcquireFlow search the MLS, find motivated sellers, and send
                offers automatically—while you focus on closing.
              </p>

              {/* Quick stats */}
              <div className="flex items-center gap-5 text-sm text-[#b8bcc8]" data-id="element-1646">
                <div className="flex items-center gap-1.5" data-id="element-1647">
                  <Zap className="w-4 h-4 text-[#3ab795]" strokeWidth={2.5} data-id="element-1648" />
                  <span className="font-medium" data-id="element-1649">1000+ offers/month</span>
                </div>
                <span className="text-[#3ab795]" data-id="element-1650">•</span>
                <div className="flex items-center gap-1.5" data-id="element-1651">
                  <Sparkles className="w-4 h-4 text-[#3ab795]" strokeWidth={2.5} data-id="element-1652" />
                  <span className="font-medium" data-id="element-1653">AI-powered</span>
                </div>
              </div>
            </div>

            {/* CTA Button with enhanced glow */}
            <a href="https://app.acquireflow.ai/signup" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center gap-3 bg-[#3ab795] text-white px-8 py-4 rounded-xl font-semibold text-lg hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-2 focus:ring-offset-[#1a1a1a] shadow-[0_0_30px_rgba(58,183,149,0.4),0_4px_16px_rgba(58,183,149,0.3)] hover:shadow-[0_0_50px_rgba(58,183,149,0.6),0_8px_24px_rgba(58,183,149,0.5)]" aria-label="Start your free trial" data-id="element-1654">
              <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-[#3ab795] to-[#2d9575] opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-2xl -z-10" data-id="element-1655" />
              <span data-id="element-1656">Start Trial</span>
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" strokeWidth={2.5} data-id="element-1657" />
            </a>

            {/* Trust badges */}
            <div className="flex items-center justify-center pt-2" data-id="element-1658">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-[#3ab795]/10 border border-[#3ab795]/20" data-id="element-1659">
                <Shield className="w-4 h-4 text-[#3ab795]" strokeWidth={2.5} data-id="element-1660" />
                <span className="text-sm font-medium text-[#3ab795]" data-id="element-1661">
                  30-day money-back guarantee
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};